import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Typography } from "@mui/material";
import { CheckMark } from "@tomocredit/common-fe/components";
import GradientButton from "@tomocredit/common-fe/components/common/GradientButton";
import RightArrowIcon from "images/arrow-right-double.svg";
import PurpleLine from "images/kosmofi/kosmofi-line.svg";
// import BannerDesktop from "images/kosmofi/kosmofi-banner-desktop.png";
import BannerMobile from "images/kosmofi/kosmofi-banner-mobile.png";
import ImageBuildYourCreditScore from "images/kosmofi/kosmofi-build_your_credit_score.webp";
import ImageCustomizableSpendingPower from "images/kosmofi/kosmofi-customizable_spending_power.webp";
import ImageNoCreditHistory from "images/kosmofi/kosmofi-no_credit_history.webp";
import { BreakpointContext } from "components/common";
import BoostHeader from "components/BoostHeader";
import AutoplayCarousel from "common/AutoplayCarousel";
import TestimonialCard1 from "images/boost/boost_testimonial_card-1.webp";
import TestimonialCard2 from "images/boost/boost_testimonial_card-2.webp";
import TestimonialCard3 from "images/boost/boost_testimonial_card-3.webp";
import TestimonialCard4 from "images/boost/boost_testimonial_card-4.webp";
import BusinessCardSpin from "images/business-card-spin.gif";
import boostWave from "images/boost/boost-wave.webp";
import { socialProofImages } from "pages/Boost/utils";
import BoostFooter from "components/BoostFooter";
import { Helmet } from "react-helmet";
import LandingForm from "./LandingForm";

const ActionButton = ({ text, isMobile }) => {
  const history = useHistory();
  return (
    <GradientButton
      clickMethod={() => history.push("/boost-pricing")}
      background="rgba(114, 73, 245, 1)"
      width={isMobile ? "100%" : "75%"}
      fontWeight={isMobile ? 600 : 800}
    >
      <span className="flex flex-row ignore text-white text-lg">
        {text}
        <img alt="" src={RightArrowIcon} />
      </span>
    </GradientButton>
  );
};

const HeaderTypography = ({ children, highlight = false }) => {
  return (
    <Typography
      component="span"
      sx={{
        color: highlight ? "rgba(142, 109, 247, 1)" : "rgba(255, 255, 255, 1)",
        textShadow: "0px 0px 24px rgba(142, 109, 247, 1)",
        fontSize: "1.5rem",
        fontWeight: 800,
        fontFamily: "Gilroy",
      }}
    >
      {children}
    </Typography>
  );
};

const KosmofiLanding = () => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md");

  return (
    <div className="flex flex-col min-h-screen h-full lg:overflow-hidden lg:pb-0" style={{  }}>
      <Helmet>
        <title>Tomo: The VIP Business Card to Boost Your Credit Fast</title>
      </Helmet>
      <div className="bg-black w-full">
        <BoostHeader />
      </div>
      <div className="relative flex flex-col pt-4 md:pt-16 lg:pt-0 lg:flex-row-reverse h-full justify-center md:items-start md:justify-start bg-black lg:min-h-[601px] overflow-hidden">
        {belowMd &&
          <div className="grid place-items-center mt-4">
            <img
              src={BannerMobile}
              alt="Kosmofi Background"
              style={{ height: "240px", width: "auto" }}
            />
          </div>
        }
        {belowMd &&
          <div className="w-full grid place-items-center mt-2">
            <div className="">
              <HeaderTypography>Build Credit, Grow Business</HeaderTypography>
            </div>
          </div>
        }
        {belowMd &&
          <div className="grid place-items-center w-full">
            <div className="text-lg">
              <CheckMark className="my-2" color="boost">
                <span className="ml-3">
                  Up to <span className="font-bold"> $30,000 credit line</span>
                </span>
              </CheckMark>
              <CheckMark className="my-2" color="boost">
                <span className="ml-3">
                  <span className="font-bold">105+ </span>
                  <span>credit boost</span>
                </span>
              </CheckMark>
              <CheckMark className="my-2" color="boost">
                <span className="ml-3 relative">
                  No credit checks. <span className="font-bold">Ever.</span>
                </span>
              </CheckMark>
            </div>
          </div>
        }
        <div className="flex flex-row w-full lg:min-h-[601px]">
          <div className="flex lg:self-center w-full justify-center md:mt-12 lg:mt-0 lg:justify-start lg:pl-24 lg:items-center">
            <LandingForm />
          </div>
          {!belowMd && <img src={BusinessCardSpin} alt="" style={{ width: "504px", height: "504px", position: "absolute", bottom: "0", right: "0" }}/>}
        </div>
        {belowMd && <div className="w-full grid place-items-center md:bg-neutral-300">
          {/* TESTIMONIAL CARDS SECTION */}
          <div
            className="mt-10 md:mt-24 flex flex-col justify-center items-center mx-auto"
            style={{ maxWidth: 1300 }}
          >
            <div className="font-bold text-2xl text-boost-primary-700 hidden md:block">Hear what others have to say</div>
            <div className="flex overflow-x-scroll hide-x-scrollbar shrink-0 w-full">
              <div className="mx-6 md:mx-10 mt-5 pb-10 flex self-start overflow-visible">
                {
                  [TestimonialCard1, TestimonialCard2, TestimonialCard3, TestimonialCard4]
                    .map((imageSrc, idx) => (
                      <img
                        alt=""
                        src={imageSrc}
                        // eslint-disable-next-line react/no-array-index-key
                        key={`testimonial-${idx}`}
                        style={{ width: "268px", height: "auto" }}
                        className="pr-6 box-content transform hover:scale-110 transition-transform"
                      />
                    ))
                }
              </div>
            </div>
          </div>
        </div>}
      </div>
      <div className="bg-neutral-300 flex flex-col w-full">
        {!belowMd && <div className="w-full grid place-items-center md:bg-neutral-300">
          {/* TESTIMONIAL CARDS SECTION */}
          <div
            className="mt-6 flex flex-col justify-center items-center mx-auto"
            style={{ maxWidth: 1300 }}
          >
            <div className="font-bold text-2xl text-boost-primary-700 hidden md:block">Hear what others have to say</div>
            <div className="flex overflow-x-scroll hide-x-scrollbar shrink-0 w-full">
              <div className="mx-6 md:mx-10 mt-5 pb-10 flex self-start overflow-visible">
                {
                  [TestimonialCard1, TestimonialCard2, TestimonialCard3, TestimonialCard4]
                    .map((imageSrc, idx) => (
                      <img
                        alt=""
                        src={imageSrc}
                        // eslint-disable-next-line react/no-array-index-key
                        key={`testimonial-${idx}`}
                        style={{ width: "268px", height: "auto" }}
                        className="pr-6 box-content transform hover:scale-110 transition-transform"
                      />
                    ))
                }
              </div>
            </div>
          </div>
        </div>}
        {/* SOCIAL PROOF CAROUSEL */}
        <div className="py-8 bg-neutral-300">
          <AutoplayCarousel
            titleText="As mentioned in"
            duplicationFactor={3}
            totalWidthPreload={7752} // will need to change this if adding/removing image
            items={socialProofImages.map((item) => {
              return (
                <div className="" style={{ height: 30 }}>
                  <img src={item.img} alt={item.alt} className="" />
                </div>
              );
            })}
            isPurpleText
          />
        </div>
      </div>
      {/* PAGE BREAK */}
      <div className="py-10 flex flex-col text-center justify-center items-center bg-white text-black">
        <h2 className="font-bold text-center leading-tight px-10 md:px-0" style={{ letterSpacing: -0.25, maxWidth: 577, fontSize: belowMd ? 24 : 36 }}>
          Opens opportunities for every business owner to achieve more
        </h2>
        <img src={PurpleLine} alt="" className="mt-2" style={{ width: 198, height: "auto" }} />
      </div>
      <div className="bg-neutral-50 text-black">
        <div className="mx-auto px-6" style={{ maxWidth: belowMd ? 564 : 1151 }}>
          {/* NO CREDIT HISTORY */}
          <div
            className="py-8 md:py-0 grid grid-cols-1 md:grid-cols-2 md:gap-4 box-border mx-auto"
            style={{ height: belowMd ? undefined : 643 }}
          >
            <div className="flex justify-center items-center order-1 md:order-2">
              <img alt="" src={ImageNoCreditHistory} className="" style={{ maxWidth: belowMd ? 342 : 423, height: "auto", objectFit: "cover" }} />
            </div>
            <div className="flex justify-center items-center order-2 md:order-1">
              <div className="py-8 sm:px-8 md:px-10 md:pt-[60px] md:pb-[45px] flex-1 flex flex-col rounded-lg shrink-0 text-left gap-6">
                <div className="flex flex-col gap-6 md:border md:bg-[rgba(192,185,251,0.6)] md:rounded-3xl md:p-10">
                  <div className="font-bold leading-tight text-4xl text-boost-primary-700 md:text-black">
                    No credit history required
                  </div>
                  <div style={{ letterSpacing: 0.1 }}>You are worth more than just a number (a.k.a. an arbitrary credit score). We conduct individualized assessments based on financial history and other sources and use our proprietary algorithm to determine your credit worthiness.</div>
                </div>
                <div className="w-full grid place-items-center">
                  <ActionButton text="Get Started Today" isMobile={belowMd} />
                </div>
              </div>
            </div>
          </div>
          {/* BUILD YOUR CREDIT SCORE */}
          <div
            className="py-8 md:py-0 grid grid-cols-1 md:grid-cols-2 md:gap-4 box-border mx-auto"
            style={{ height: belowMd ? undefined : 643 }}
          >
            <div className="flex justify-center items-center order-1">
              <img alt="" src={ImageBuildYourCreditScore} className="w-full" style={{ maxWidth: belowMd ? 342 : 438, height: "auto", objectFit: "cover" }} />
            </div>
            <div className="flex justify-center items-center order-2">
              <div className="bg-neutral-50 py-8 sm:px-8 md:px-10 md:pt-[60px] md:pb-[45px] flex-1 flex flex-col rounded-lg shrink-0 text-left gap-6">
                <div className="flex flex-col gap-6 md:border md:bg-[rgba(192,185,251,0.6)] md:rounded-3xl md:p-10">
                  <div className="font-bold leading-tight text-4xl text-boost-primary-700 md:text-black">
                    Build Your Credit Score
                  </div>
                  <div className="" style={{ letterSpacing: 0.1 }}>Through consistent on-time payments, your credit score will grow. Set up an &quot;optional&quot; 7 day pay to maximize this cycle and increase the rate in which your credit score can improve.</div>
                </div>
                <div className="w-full grid place-items-center">
                  <ActionButton text="Build Your Credit Now" isMobile={belowMd} />
                </div>
              </div>
            </div>
          </div>
          {/* CUSTOMIZABLE SPENDING POWER */}
          <div
            className="py-8 md:py-0 grid grid-cols-1 md:grid-cols-2 md:gap-4 box-border mx-auto"
            style={{ height: belowMd ? undefined : 643 }}
          >
            <div className="flex justify-center items-center order-1 md:order-2">
              <img alt="" src={ImageCustomizableSpendingPower} className="w-full" style={{ maxWidth: 428, height: "auto", objectFit: "cover" }} />
            </div>
            <div className="flex justify-center items-center order-2 md:order-1">
              <div className="bg-neutral-50 py-8 sm:px-8 md:px-10 md:pt-[60px] md:pb-[45px] flex-1 flex flex-col rounded-lg shrink-0 text-left gap-6">
                <div className="flex flex-col gap-6 md:border md:bg-[rgba(192,185,251,0.6)] md:rounded-3xl md:p-10">
                  <div className="font-bold leading-tight text-4xl text-boost-primary-700 md:text-black">
                    Customizable Spending Power
                  </div>
                  <div className="" style={{ letterSpacing: 0.1 }}>Since we do not rely on a credit score to determine your spending power, we have the flexibility to update your spending power in real time! Spending power ranges from $100 - $30,000.*</div>
                  <div className=" text-xs" style={{ letterSpacing: 0.1 }}>* Not all applicants will be approved for the maximum spending power.</div>
                </div>
                <div className="w-full grid place-items-center">
                  <ActionButton text="Take Control of Your Credit" isMobile={belowMd} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 bg-black">
        <BoostFooter isBelow={isBelow}/>
        <img src={boostWave} alt="" className="w-full xl:w-1/2" />
      </div>
    </div>
  );
};

export default KosmofiLanding;
